// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__ln8Cy","gradientOverlay":"style_gradientOverlay__EKc7M","innerGradient":"style_innerGradient__jkniu"};